import { StaticImageData } from "next/image";

import demo_img_1 from "@/assets/img/menu/home-1.jpg";
import demo_img_2 from "@/assets/img/menu/home-2.jpg";
import demo_img_3 from "@/assets/img/menu/home-3.jpg";

interface DataType {
  id: number;
  title: string;
  link: string;
  img_dropdown?: boolean;
  has_dropdown?: boolean;
  sub_menus?: {
    link: string;
    title: string;
    btn_title?: string;
    one_page_link?: string | any;
    one_page_title?: string;
    demo_img?: StaticImageData | any;
    mobile_menu?: boolean;
  }[];
}
[];
// menu data
const menu_data: DataType[] = [
  {
    id: 1,
    title: "Home",
    link: "/",
    has_dropdown: false,
  },
  {
    id: 2,
    title: "About",
    link: "/about",
    has_dropdown: false,
  },

  {
    id: 3,
    title: "Ghostwriting",
    link: "/ghostwriting",
    has_dropdown: false,
  },
  {
    id: 3,
    title: "Developmental Editing",
    link: "/developmental-editing",
    has_dropdown: false,
  },
  {
    id: 4,
    title: "Idea Development",
    link: "/idea-development",
    has_dropdown: false,
  },
{
    id: 5,
    title: "Coaching",
    link: "/coaching",
    has_dropdown: false,
  },
  {
    id: 6,
    title: "FAQs",
    link: "/faqs",
    has_dropdown: false,
  },
];
export default menu_data;
